
import { KeyboardLayouts } from '../../../SimpleKeyboard/Layout';
import { isElectron } from '../../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormTextArea } from './KioskFormTextArea/KioskFormTextArea';
import { WebFormTextArea } from './WebFormTextArea/WebFormTextArea';
import { FormTextAreaProps } from './FormTextArea.types';

const FormTextArea = ({
    name,
    id,
    title,
    label,
    ariaLabel,
    placeholder,
    disabled,
    required,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    shiftAfterAmpersand = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    helperText,
}: FormTextAreaProps) => {
    return isElectron() ? (
        <KioskFormTextArea
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            keyboardLayout={keyboardLayout}
            shiftAfterSpace={shiftAfterSpace}
            shiftAfterPeriod={shiftAfterPeriod}
            shiftAfterAmpersand={shiftAfterAmpersand}
            hideKeyboardOnClickOut={hideKeyboardOnClickOut}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            placeholder={placeholder}
            helperText={helperText}
        />
    ) : (
        <WebFormTextArea
            name={name}
            id={id}
            title={title}
            label={label}
            ariaLabel={ariaLabel}
            disabled={disabled}
            required={required}
            autoFocus={autoFocus}
            capsLock={capsLock}
            fullWidth={fullWidth}
            seventyFivePercentWidth={seventyFivePercentWidth}
            tabFocusRefContext={tabFocusRefContext}
            placeholder={placeholder}
            helperText={helperText}
        />
    );
};

export default FormTextArea;
